/**
 * Help Button Component
 * Reusable contextual help trigger — opens the Central de Ajuda hub
 * for the current screen in a new browser tab.
 */

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

export interface HelpButtonProps {
  entity: string;
  screen: string;
  size?: 'small' | 'medium';
}

export const HelpButton: React.FC<HelpButtonProps> = ({ entity, screen, size = 'medium' }) => {
  const handleClick = () => {
    const url = `/ajuda/${entity}/${screen}`;
    window.open(url, '_blank', 'noopener');
  };

  return (
    <Tooltip title="Ajuda desta tela">
      <IconButton
        color="inherit"
        size={size}
        onClick={handleClick}
        aria-label="Ajuda desta tela"
      >
        <HelpOutline fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default HelpButton;
